export const stripHtml = (value = '') => value
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const sanitizeRichText = (value = '') => {
    if (typeof document === 'undefined') return value;

    const allowedTags = ['A', 'BR', 'DIV', 'EM', 'LI', 'OL', 'P', 'SPAN', 'STRONG', 'U', 'UL'];
    const allowedAttributes = {
        A: ['href', 'target', 'rel'],
        LI: ['class'],
        OL: ['class'],
        P: ['class'],
        SPAN: ['class'],
        UL: ['class']
    };
    const container = document.createElement('div');
    container.innerHTML = value;

    const cleanNode = (node) => {
        Array.from(node.children).forEach(child => {
            if (!allowedTags.includes(child.tagName)) {
                child.parentNode.replaceChild(document.createTextNode(child.textContent || ''), child);
                return;
            }

            Array.from(child.attributes).forEach(attribute => {
                const allowedForTag = allowedAttributes[child.tagName] || [];
                if (!allowedForTag.includes(attribute.name)) {
                    child.removeAttribute(attribute.name);
                }
            });

            if (child.tagName === 'A') {
                const href = child.getAttribute('href') || '';
                if (!/^https?:\/\//i.test(href) && !/^mailto:/i.test(href)) {
                    child.removeAttribute('href');
                }
                child.setAttribute('target', '_blank');
                child.setAttribute('rel', 'noopener noreferrer');
            }

            cleanNode(child);
        });
    };

    cleanNode(container);
    return container.innerHTML;
};



// WEBPACK FOOTER //
// ./src/views/util/richText.js